import type { BreadcrumbLinkProps } from '@/components/Breadcrumbs/types';
import type { CategoryHeader } from '@/utils/pages/api';
import { getBreadcrumbLink } from './get-breadcrumb-link';

export const getBreadcrumbChildren = ({
  taxonomy,
}: {
  taxonomy: CategoryHeader['taxonomy'];
}) => {
  const canonicalChildren = taxonomy.filter(
    (item) => item.is_canonical === true && item.is_parent === false
  );

  canonicalChildren.sort((a, b) => {
    const aName = a?.breadcrumb_name?.length ? a.breadcrumb_name : a.name;
    const bName = b?.breadcrumb_name?.length ? b.breadcrumb_name : b.name;

    return aName.localeCompare(bName);
  });

  const result: BreadcrumbLinkProps[] = canonicalChildren.map((item) => {
    const breadcrumbLink = getBreadcrumbLink({ data: item });

    return breadcrumbLink;
  });

  return result;
};
